const buildObjectForGuest = (label, val) => {
  const obj = {};
  obj[label] = val;
  return obj;
};

const buildIdObjectFromKey = key => {
  const valueArr = key.split('-');
  return {
    addOnId: valueArr[0],
    pkgId: valueArr[1],
    ind: parseInt(valueArr[2]),
    fieldLabel: valueArr[3]
  };
};

export default values => {
  const addOnGuests = {};
  Object.keys(values).forEach(k => {
    var val = values[k];
    const idObj = buildIdObjectFromKey(k);

    const matchingPkg = addOnGuests[idObj.pkgId];

    if (matchingPkg) {
      const matchingAddOn = matchingPkg[idObj.addOnId];

      if (matchingAddOn) {
        const matchingGuest = matchingAddOn[idObj.ind];

        if (matchingGuest) {
          matchingGuest[idObj.fieldLabel] = val;
        } else {
          matchingAddOn.push(buildObjectForGuest(idObj.fieldLabel, val));
        }
      } else {
        matchingPkg[idObj.addOnId] = [
          buildObjectForGuest(idObj.fieldLabel, val)
        ];
      }
    } else {
      addOnGuests[idObj.pkgId] = {};
      addOnGuests[idObj.pkgId][idObj.addOnId] = [
        buildObjectForGuest(idObj.fieldLabel, val)
      ];
    }
  });

  return addOnGuests;
};
